// PieceType enum
export enum PieceType {
  PAWN = 'P',
  BISHOP = 'B',
  KNIGHT = 'N',
  ROOK = 'R',
  QUEEN = 'Q',
  KING = 'K',
}

// TeamType enum
export enum TeamType {
  RED = 'r',
  BLUE = 'b',
  YELLOW = 'y',
  GREEN = 'g',
}
